/**
 * @param input 9 digits for phone number in string or numbers
 * @param excludeLongDistance Boolean to exclude the `+1` from phone number
 * @param forceLongDistance Adds `+1` to the phone number
 * @returns Empyt if no valid phone number or formatted. `Ex: +1 ()`
*/
export const formatNumberToPhone = (input: string | number): string => {
  if (!(input && `${(input || '')}`.length > 9)) { return ''; }

  const cleaned = (`${(input || '')}`).replace(/\D/g, '');

  // Case: 10 digits
  if (cleaned.length === 10) {
    // If 10 digits long, prepend a '1' for formatting purposes
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (!match) return '';
    return `+1 (${match[1]}) ${match[2]}-${match[3]}`;
  }

  // Case: 11 digits starting with 1
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    const match = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
    if (!match) return '';
    return `+1 (${match[1]}) ${match[2]}-${match[3]}`;
  }

  return '';
};
